import { Button, Popover, PopoverContent, PopoverTrigger } from '@ibsys/kit';
import { DownloadIcon } from 'lucide-react';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { FileDownloadFormat } from '@/shared/lib';
import { DownloadFormatBadges } from '../DownloadFormatBadges';

type Props = {
  /** Выгрузка в выбранном формате */
  onDownload: (format: FileDownloadFormat) => void;
  /** Файл формируется — повторное скачивание не запускается */
  isPending: boolean;
  /** Классы кнопки-триггера */
  className?: string;
};

/**
 * Кнопка скачивания файлом с выбором формата лейблами {@link DownloadFormatBadges}:
 * скачивание запускает выбор лейбла, отдельного действия «скачать» у кнопки нет — формат
 * обязателен. Применяется там, где состав документа задаёт система, а пользователю остаётся
 * только формат. Список раскрывается всплывающим окном, а не меню: равноправные действия
 * в одной строке меню обходились бы только Tab'ом.
 */
export const DownloadFormatButton: FC<Props> = ({ onDownload, isPending, className }) => {
  const { t } = useTranslation('common');
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (format: FileDownloadFormat) => {
    setIsOpen(false);
    onDownload(format);
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={className}
          aria-label={t('download')}
          disabled={isPending}
          icon={<DownloadIcon className="size-4" />}
        />
      </PopoverTrigger>
      <PopoverContent align="end" className="w-auto p-2">
        <DownloadFormatBadges onSelect={handleSelect} testIdPrefix="download-format" />
      </PopoverContent>
    </Popover>
  );
};
